import { Pipe, PipeTransform } from '@angular/core';
import { OrderGenerationType } from '@app/shared/enums/OrderGenerationType';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'orderGenerationType',
    standalone: false
})
export class OrderGenerationTypePipe implements PipeTransform {
  public orderGenerationType = OrderGenerationType;
  public orderGenerationTypesList: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
  }

  getList() {
    this.orderGenerationTypesList = [];

    for (const [propertyKey, propertyValue] of Object.entries(OrderGenerationType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.orderGenerationTypesList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.orderGenerationTypesList;
  }

  transform(value: any): string {
    if (value === null || value === undefined) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const generationTypes = Array.isArray(value) ? value : [value];

    if (generationTypes.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = generationTypes
      .map(generationType => {
        const key = Object.keys(OrderGenerationType).find(
          k => OrderGenerationType[k as keyof typeof OrderGenerationType] === generationType
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }
}
